import { STATUS } from '../../config/constants/states';
import {
  SET_COUPON_LIST,
  COUPON_LIST_LOADED,
  COUPON_IS_CREATED,
  COUPON_IS_EDITED,
  COUPON_IS_DELETED,
  COUPON_IS_VALID,
  COUPON_DISCOUNT,
  COUPON_IS_CONSUMED
} from './types';

const initialState = {
  couponList: {},
  listIsLoaded: false,
  isCreated: STATUS.PENDING,
  isEdited: STATUS.PENDING,
  isDeleted: STATUS.PENDING,
  isValid: STATUS.PENDING,
  isConsumed: STATUS.PENDING,
  discount: {}
};

export default function (state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case SET_COUPON_LIST:
      return { ...state, couponList: payload };
    case COUPON_LIST_LOADED:
      return { ...state, listIsLoaded: payload };
    case COUPON_IS_CREATED:
      return { ...state, isCreated: payload };
    case COUPON_IS_EDITED:
      return { ...state, isEdited: payload };
    case COUPON_IS_DELETED:
      return { ...state, isDeleted: payload };
    case COUPON_IS_VALID:
      return { ...state, isValid: payload };
    case COUPON_IS_CONSUMED:
      return { ...state, isConsumed: payload };
    case COUPON_DISCOUNT:
      return { ...state, discount: payload };
    default:
      return state;
  }
};